import { ProductListCard } from 'views/ProductlistPage/themes/BGH/productListCard';
import { hasElements, rm } from 'utils';
import { Grid, Cell } from 'components/Grid';
import { Section } from 'components/Section';
import cn from 'classnames';
import styles from 'views/ProductlistPage/themes/BGH/styles.scss';
import { useSelector } from 'react-redux';
import { isMobile as isMobileSelector } from 'components/Shared/responsive';
import { useProductlist } from 'views/ProductlistPage/useProductList';
import { useMaxVariants } from 'views/ProductlistPage/useMaxVariants';
import { ProductlistViewProduct } from 'models/ProductlistViewProduct';
import { TrackedElement, useIntersectionObserver } from 'hooks/useIntersectionObserver';
import { GtmViewItem } from 'views/ProductlistPage/themes/BGH/productList';

const NUMBER_OF_IMAGES_TO_LOAD_DIRECTLY = 3;

type ProductListProps = {
  gtmOnItemClick: (product: ProductlistViewProduct, index: number, pageNbr: number) => void;
  gtmOnViewItem: (items: GtmViewItem[], pageNbr: number) => void;
};

export const ProductList = ({ gtmOnItemClick, gtmOnViewItem }: ProductListProps) => {
  const { pages, products, pageNbr } = useProductlist();
  const [maxVariants, ref] = useMaxVariants();
  const isMobile = useSelector(isMobileSelector);
  const isSponsored = false;

  const { setElementRef } = useIntersectionObserver({
    onBatchVisible: handleElementsVisible
  });

  function handleElementsVisible(elements: TrackedElement<ProductlistViewProduct>[]) {
    const items: GtmViewItem[] = elements.map(element => {
      const viewedProduct = element.payload;
      const productIndex = products.indexOf(viewedProduct);

      return {
        index: productIndex,
        product: viewedProduct
      };
    });

    gtmOnViewItem(items, pageNbr);
  }

  return (
    <Section
      contentClassName={cn({
        [styles.fullWidthGrid]: isMobile,
        [styles.gridSpacing]: !isMobile
      })}
    >
      {hasElements(products) ? (
        pages.map(({ page, products }) => (
          <Grid
            className={styles.grid}
            desktop="4"
            tablet="3"
            phone="1"
            gutters={isMobile ? 'hidden' : 'large'}
            key={page}
          >
            {products.map((product, index) => {
              const isLazy = index >= NUMBER_OF_IMAGES_TO_LOAD_DIRECTLY;

              return (
                <Cell
                  className={cn({ [styles.cellBorder]: isMobile })}
                  key={product.ticket}
                  ref={node => setElementRef({ ref: node, payload: product })}
                >
                  <ProductListCard
                    isLazy={isLazy}
                    maxVariants={maxVariants}
                    isSponsored={isSponsored}
                    isListView={isMobile}
                    onLinkClick={() => gtmOnItemClick(product, index, pageNbr)}
                    ref={ref}
                    {...{
                      product
                    }}
                  />
                </Cell>
              );
            })}
          </Grid>
        ))
      ) : (
        <p>{rm('no_products_message')}</p>
      )}
    </Section>
  );
};
